import Backbone from 'backbone';
import $ from 'jquery';

import * as mouse from 'util/Mouse';

interface BackdropOptions extends Backbone.ViewOptions<Backbone.Model> {
  closeOnScroll?: boolean;
}

export default class Backdrop extends Backbone.View<Backbone.Model> {
  closeEvents!: Array<string>;
  overlay!: JQuery;

  initialize(options: BackdropOptions = {}): void {
    this.closeEvents = ['mousedown'];
    if (options?.closeOnScroll) {
      this.closeEvents.push(mouse.MouseWheelEvent);
    }
    this.overlay = $('<div>').addClass('backdrop');
  }

  open(): Array<JQuery> {
    return this.closeEvents.map((closeEvent) =>
      this.overlay.one(`${closeEvent}.backdrop`, (e) => {
        this.close();
        return e.preventDefault();
      })
    );
  }

  remove(): Backbone.View<Backbone.Model> {
    this.overlay.remove();
    return super.remove();
  }

  close(): JQuery {
    this.overlay.off('.backdrop');
    return this.overlay.detach();
  }
}
